var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.componentClass,
      style: _vm.componentStyle,
      attrs: { id: "top" },
    },
    [
      _vm.isInternetExplorer ? _c("warning-internet-explorer") : _vm._e(),
      _vm._v(" "),
      _c("owa-admin-bar"),
      _vm._v(" "),
      _vm._t("tophat", function () {
        return [
          _c(
            "div",
            { staticClass: "app-tophat" },
            [
              _vm.isShowingSurveyNotice ? _c("survey-notice") : _vm._e(),
              _vm._v(" "),
              _c("subscription-notices"),
              _vm._v(" "),
              _c("usage-notices"),
              _vm._v(" "),
              _vm.isShowingNewPackNotice ? _c("new-pack-notice") : _vm._e(),
            ],
            1
          ),
        ]
      }),
      _vm._v(" "),
      _vm._t("header"),
      _vm._v(" "),
      _vm.isShowingBandana ? _vm._t("bandana") : _vm._e(),
      _vm._v(" "),
      _vm._t("sweatband"),
      _vm._v(" "),
      _vm._t("content"),
      _vm._v(" "),
      _vm._t("sock"),
      _vm._v(" "),
      _vm._t("footer"),
      _vm._v(" "),
      _vm._t("overlay"),
      _vm._v(" "),
      _c("cookie-consent"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }